import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { Button, Col, Row, Space } from "antd";
import { Input, Switch } from "components/form";
import { ACTION } from "features/payment/schemas/PaymentShemas";
import * as Yup from "yup";
import {
  initialValues as INITIAL_VALUES,
} from "../schemas/shiftsSchema";
import DoubleShiftForm from "./DoubleShiftForm";
import ShiftsAttendancePolicyForm from "./ShiftsAttendancePolicyForm";
import ShiftsOtherSettingForm from "./ShiftsOtherSettingForm";
import ShiftsPeriodsForm from "./ShiftsPeriodsForm";

const ShiftsForm = ({
  initialValues = {},
  shiftsList = [],
  attendanceConditionOptions = [],
  checkInChanelOptions = [],
  weekDayWorkingOptions = [],
  weekWorkingOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
}) => {
  const { t } = useTranslation();
  const ShiftsSchema = Yup.object().shape({
    shiftName: Yup.string().required(t('othersetting.please-enter')),
    shiftNameEn: Yup.string().required(t('othersetting.please-enter')),
    shiftCode: Yup.string().required(t('othersetting.please-enter')),
    description: Yup.string().required(t('othersetting.please-enter')),
    attendanceConditionId: Yup.string().when("doubleShift", {
      is: (val) => val === false,
      then: () => Yup.string().required(t('othersetting.please-select')),
      otherwise: () => Yup.string().notRequired(),
    }),
    checkInChanelId: Yup.string()
      .nullable()
      .when(["doubleShift", "calculateOtAuto"], {
        is: (doubleShift, calculateOtAuto) => doubleShift === false && calculateOtAuto === true,
        then: (schema) => schema.required(t('othersetting.please-select')),
      }),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...INITIAL_VALUES,
        ...initialValues,
      }}
      onSubmit={onSubmit}
      validationSchema={ShiftsSchema}
    >
      {({ values = {}, setFieldValue = () => { } }) => {
        return (
          <Form>
            <Space size={24} direction="vertical">
              <div className="card">
                <Row gutter={[24, 16]}>
                  <Col span={8}>
                    <Input
                      name="shiftName"
                      label={
                        t("shift.label.shift_name")
                      }
                      placeholder={
                        t("shift.placeholders.shift_name")
                      }
                      size="large"
                      disabled={values?.type === ACTION.VIEW}
                      required
                    />
                  </Col>
                  <Col span={8}>
                    <Input
                      name="shiftNameEn"
                      label={
                        t("shift.label.shift_name_eng")
                      }
                      placeholder={
                        t("shift.placeholders.shift_name_eng")
                      }
                      size="large"
                      disabled={values?.type === ACTION.VIEW}
                      required
                    />
                  </Col>
                  <Col span={8}>
                    <Input
                      name="shiftCode"
                      label={
                        t("shift.label.shift_code")
                      }
                      placeholder={
                        t("shift.placeholders.shift_code")
                      }
                      size="large"
                      disabled={values?.type === ACTION.VIEW}
                      required
                    />
                  </Col>
                  <Col span={24}>
                    <Input
                      name="description"
                      label={
                        t("shift.label.description")
                      }
                      placeholder={
                        t("shift.placeholders.description")
                      }
                      size="large"
                      disabled={values?.type === ACTION.VIEW}
                      required
                    />
                  </Col>
                  <Col span={12}>
                    <Switch
                      name="doubleShift"
                      label={t("shift.label.double_shift")}
                      disabled={values?.type === ACTION.VIEW}
                    />
                  </Col>
                  {values.doubleShift ? (
                    <></>
                  ) : (
                    <>
                      <Col span={12}>
                        <Switch
                          name="nightShift"
                          label={t("shift.label.night_shift")}
                          disabled={values?.type === ACTION.VIEW}
                        />
                      </Col>
                      <Col span={12}>
                        <p>{t("shift.label.ship_periods")}</p>
                      </Col>
                      {/* <Col span={12}>
                        <Switch
                          name="advanceSetting"
                          label={t("shift.label.advance_setting")}
                        />
                      </Col> */}
                    </>
                  )}
                </Row>
                {values.doubleShift ? (
                  <div className="card">
                    <DoubleShiftForm shiftsList={shiftsList} values={values} />
                  </div>
                ) : (
                  <div className="card">
                    <ShiftsPeriodsForm
                      values={values}
                      weekDayWorkingOptions={weekDayWorkingOptions}
                      weekWorkingOptions={weekWorkingOptions}
                    />
                  </div>
                )}
                {values.doubleShift ? (
                  <></>
                ) : (
                  <Col span={24}>
                    <ShiftsAttendancePolicyForm
                      values={values}
                      attendanceConditionOptions={attendanceConditionOptions}
                      setFieldValue={setFieldValue}
                    />
                    <ShiftsOtherSettingForm
                      values={values}
                      checkInChanelOptions={checkInChanelOptions}
                      setFieldValue={setFieldValue}
                    />
                  </Col>
                )}
                <Row justify="end" style={{ paddingTop: "24px" }}>
                  <Space size={12}>
                    <Button type="default" onClick={onCancel} style={{ height: "40px", borderRadius: "8px" }}>
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    {values?.type !== ACTION.VIEW && (
                      <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                        {t("common.submit").toUpperCase()}
                      </Button>
                    )}
                  </Space>
                </Row>
              </div>
            </Space>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ShiftsForm;
